<template>
  <!-- begin login -->
  <div class="login login-with-news-feed">
    <!-- begin news-feed -->
    <div class="news-feed">
      <div class="news-image"></div>
      <div class="news-caption">
        <h4 class="caption-title"><b>META</b></h4>
        <p>
          It's very expensive to bring a new customer in the store. So do
          whatever you can do for your existing customers.
        </p>
      </div>
    </div>
    <!-- end news-feed -->
    <!-- begin right-content -->
    <div class="right-content">
      <!-- begin login-header -->
      <div class="login-header">
        <div class="brand">
          <img
            class="ts-mb-4"
            v-lazy="{
              src: companyLogo,
              error: require('@/assets/logo.jpg')
            }"
            style="width: 67%; height: 100%; object-fit: cover"
          />
          <b>POS</b> 360+
          <small>POS Management Solution</small>
        </div>
      </div>
      <!-- end login-header -->
      <!-- begin login-content -->
      <div class="login-content">
        <form @submit.prevent="login" class="margin-bottom-0">
          <div
            class="alert alert-danger fade show ts-mb-4"
            v-show="errorMessage != ''"
          >
            {{ errorMessage }}
          </div>
          <div class="form-group m-b-15">
            <input
              type="text"
              class="form-control form-control-lg"
              placeholder="Username"
              :class="{ 'is-invalid': errors.has('username') }"
              v-model="username"
              ref="username"
            />
            <div class="invalid-feedback" v-if="errors.has('username')">
              {{ errors.first('username') }}
            </div>
          </div>
          <div class="form-group m-b-15">
            <input
              type="password"
              class="form-control form-control-lg"
              placeholder="Password"
              :class="{ 'is-invalid': errors.has('password') }"
              v-model="password"
            />
            <div class="invalid-feedback" v-if="errors.has('password')">
              {{ errors.first('password') }}
            </div>
          </div>
          <div class="checkbox checkbox-css m-b-30">
            <input type="checkbox" id="remember_me_checkbox" value="" />
            <label for="remember_me_checkbox"> Remember Me </label>
          </div>
          <div class="login-buttons">
            <ts-button
              type="submit"
              color="success"
              class="btn-block btn-lg"
              :waiting="loggingIn"
            >
              Sign me in
            </ts-button>
          </div>
          <div class="m-t-20 m-b-40 p-b-40 text-inverse">
            Not a member yet? Click
            <router-link to="/user/register-v3" class="text-success"
              >here</router-link
            >
            to register.
          </div>
          <hr />
          <p class="text-center text-grey-darker">
            POWERED BY: TECHSTORE CREATIVE SOLUTIONS
          </p>
        </form>
      </div>
      <!-- end login-content -->
    </div>
    <!-- end right-container -->
  </div>
  <!-- end login -->
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import PageOptions from '../config/PageOptions.vue'

export default {
  name: 'Login',
  data () {
    return {
      username: null,
      password: null,
      guard: 'ADMIN_GUARD_SECRET',
      errors: new Errors(),
      errorMessage: '',
      loggingIn: false,
      companyLogo: ''
    }
  },
  computed: {
    currentYear () {
      return moment().year()
    },
    appName () {
      return process.env.VUE_APP_NAME
    }
  },
  mounted () {
    this.$refs.username.focus()
  },
  created () {
    // PageOptions.pageEmpty = true
    document.body.className = 'bg-white'
    this.fetchLogo()
  },
  beforeRouteLeave (to, from, next) {
    PageOptions.pageEmpty = false
    document.body.className = ''
    next()
  },
  methods: {
    fetchLogo () {
      this.$store
        .dispatch('companryLogo')
        .then(response => {
          this.companyLogo = response.company_logo
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async login () {
      this.errors = new Errors()
      this.errorMessage = ''
      this.loggingIn = true
      try {
        await this.$store.dispatch('login', {
          username: this.username,
          password: this.password,
          guard: this.guard
        })
        this.$parent.resetTimer()
        this.$store.state.isLockScreen = false
        this.$nextTick(() => {
          PageOptions.pageEmpty = false
          this.$forceUpdate()
        })
        await this.$router.go(this.$route.query.redirectTo || { name: 'home' })
      } catch (errorResponse) {
        if (errorResponse.errors) {
          this.errors = new Errors(errorResponse.errors)
        } else if (errorResponse.message) {
          this.errorMessage = errorResponse.message
        }
      }

      this.loggingIn = false
    }
  }
}
</script>

<style scoped lang="scss">
.news-image {
  background-image: url('../assets/login_bg.jpg');
}
</style>
